import React, { useEffect, useRef, useState } from "react";

const ExpandableText = ({ text, className, onCollapse }: { text: string, className: string, onCollapse?: () => void }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const summaryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (summaryRef.current) {
      const element = summaryRef.current;
      const shouldTruncate = element.scrollHeight > element.clientHeight;
      setShowViewMore(shouldTruncate);
    }
  }, [text]);

  const maxHeight = '22em'; // Approximately 15 lines of text
  const fadeStartHeight = `${parseFloat(maxHeight) * 0.67}em`;  // Fade starts at 67% to show most content before truncating

  return (
    <div className={className}>
      <div 
        ref={summaryRef}
        style={{
          maxHeight: isExpanded ? 'none' : maxHeight,
          height: 'auto',
          overflow: isExpanded ? 'visible' : 'hidden',
          lineHeight: '1.5em',
          transition: 'height 0.3s ease-in-out',
          position: 'relative'
        }}
      >
        {text}
        {!isExpanded && showViewMore && (
          <div 
            style={{
              content: '',
              width: '100%',
              height: '100%',
              position: 'absolute',
              left: 0,
              top: 0,
              background: `linear-gradient(transparent ${fadeStartHeight}, var(--theme-color-5))`,
              pointerEvents: 'none'
            }}
          />
        )}
      </div>
      {showViewMore && (
        <span
          onClick={(e) => {
            e.stopPropagation();
            const newExpandedState = !isExpanded;
            setIsExpanded(newExpandedState);

            // Scroll to the top of text when collapsing
            if (!newExpandedState && onCollapse) {
              onCollapse();
            }
          }}
          style={{
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '0.9em',
            textDecoration: 'underline',
            marginTop: '0.25em',
            opacity: 0.7,
            display: 'inline-block'
          }}
          className="view-more-link"
        >
          {isExpanded ? 'View Less' : 'View More'}
        </span>
      )}
    </div>
  );
};

export default ExpandableText;